module.exports = __webpack_public_path__ + "static/media/contact-kuara.d93776f7.svg";